// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_3Gabt--ZvX6tP6ImVulfEZ"};